export default{
    lab: "آزمایشگاه",
    date: "تاریخ",
    spermConcentration: "غلظت اسپرم",
    totalSpermNumber: "تعداد اسپرم",
    progressiveMotility: "تحرک پیشرفته",
    normalForms: "فرم‌های عادی",
}